import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HelmetProvider } from "react-helmet-async";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

// Temporarily enable copy and cut event handlers per user request (will re-enable later)

// Disable right-click context menu
// document.addEventListener("contextmenu", (e) => e.preventDefault());
// document.addEventListener("copy", (e) => e.preventDefault());
// document.addEventListener("cut", (e) => e.preventDefault());
// document.addEventListener("dragstart", (e) => e.preventDefault());

// // Disable keyboard shortcuts for devtools, save, printing
// document.addEventListener("keydown", (e) => {
//   if (
//     e.key === "F12" ||
//     (e.ctrlKey && e.shiftKey && ["I", "J", "C", "i", "j", "c"].includes(e.key)) ||
//     (e.ctrlKey && ["U", "u", "S", "s", "P", "p"].includes(e.key))
//   ) {
//     e.preventDefault();
//   }
// });

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </HelmetProvider>
  </React.StrictMode>,
);
